<div class="popup forms ">
  <div class="cancel" (click)="no()"><i class="fa fa-times"></i></div>
  <div><h1>Unsubscribe</h1></div>
  <p>Would you like to unsubscribe from all non-transactional emails? You will continue to receive transactional emails related to your account and orders.</p>
  <div class="row text-center">
    <button (click)="no()" class="btn btn-danger"><i class="fa fa-times"></i> No</button>
    <button  (click)="yes()"  class="btn btn-warning"><i class="fa fa-check"></i> Yes</button>
  </div>
</div>
